import Vue from 'vue'
import Component from 'vue-class-component'

import { ApiService, ApiServiceImpl } from './service/ApiService'
import { AuthService, AuthServiceImpl } from './service/AuthService'

import TYPES from './config/Types'
import { DependencyContainer } from '@/config/DependencyContainer'
import authStore from '@/store/auth/auth-store';

@Component({
  name: 'App'
})

export default class App extends Vue {
  get authInitialized () { return authStore.isInitialized }

  /*
  // Accordion
  public myFunction(id): void {
  var x = document.getElementById(id)
  if (x.className.indexOf('w3-show') === -1) {
    x.className += ' w3-show'
    x.previousElementSibling.className += ' w3-theme-d1'
  } else {
    x.className = x.className.replace('w3-show', '')
    x.previousElementSibling.className = x.previousElementSibling.className.replace(' w3-theme-d1', '')
  }
  }

  // Used to toggle the menu on smaller screens when clicking on the menu button
  public openNav (): void {
  var x = document.getElementById('navDemo')
  if (x.className.indexOf('w3-show') === -1) {
    x.className += ' w3-show'
  } else {
    x.className = x.className.replace(' w3-show', '')
  }
  }
 */
}
